import Vue from 'vue';
const eventHub = new Vue();
import VueCookies from 'vue-cookies';
import logo from './assets/logo.png';

export default {

	watch : {
		'userRoles' : function(){
			let allowed = [];
			for(let role of this.userRoles){
				if(role.name == 'admin'){
					allowed.push('admin');
				}
				else if(role.name == 'uploader'){
					allowed.push('uploader');
				}
			};

			this.allowedNavigations = allowed;
			this.eventHub.$emit("allowedNavigations", allowed);
		},

		'openForcePassword' : function(){
			if(!this.openForcePassword){
				this.eventHub.$emit("closeForcePassword");
			}
		},

		'userData' : function(){
			
		}
	},

	mounted : function(){
		let cookie = VueCookies.get(this.cookieKey);
        if(cookie != null){
            this.userData = JSON.parse( JSON.stringify(cookie.data.user) );
        }
	},

	data : function(){
		return {

			//apiUrl : 'http://localhost/projects/online-payslip/api',
			apiUrl : 'https://payslip-api.sgccserver02.com/',
			cookieKey : 'sterlingEmployee',
			logo : logo,
			userRoles : [],
			userData : {},
			allowedNavigations : [],
			eventHub: eventHub,
			openForcePassword : false,
			formRules: {
                required: value => !!value || 'Required.',
                email: value => {
	                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	                return pattern.test(value) || 'Invalid e-mail.'
	            },
	            phNumber : (inputNumber) =>{
	            	let reg = new RegExp(/^(\+639)\d{9}$/);
	            	return (reg.test(inputNumber)) ? true : 'Must be valid PH Mobile Number e.g(+639XXXXXXXXX)';
	            }
            }

		}
	},
	methods : {



	}

};